import { AuthContext } from 'context'
import { useContext } from 'react'

// Auth context hook
const useAuth = () => useContext(AuthContext)

export { useAuth }
